var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAppleDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6278_50493)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0709 3.36243C13.8 2.51744 14.2914 1.34054 14.1569 0.169556C13.1063 0.209556 11.8352 0.840702 11.0819 1.68469C10.4054 2.43368 9.81484 3.63045 9.97359 4.77844C11.1456 4.86543 12.3418 4.20841 13.0709 3.36243ZM15.699 10.7946C15.7283 13.8215 18.4697 14.8284 18.5 14.8414C18.4778 14.9124 18.0622 16.2762 17.056 17.6862C16.1854 18.9041 15.2824 20.1172 13.8596 20.1432C12.4621 20.1682 12.0122 19.3492 10.4135 19.3492C8.81577 19.3492 8.31624 20.1171 6.9936 20.1681C5.62039 20.2171 4.5738 18.8503 3.6971 17.6364C1.90323 15.1534 0.533065 10.6196 2.37344 7.55969C3.28756 6.04071 4.92064 5.07734 6.69428 5.05334C8.04221 5.02834 9.31531 5.92249 10.1394 5.92249C10.9636 5.92249 12.5107 4.84749 14.1367 5.00549C14.8172 5.03249 16.7284 5.26841 17.955 6.98938C17.8559 7.04838 15.6747 8.2646 15.699 10.7946Z",
    fill: "#A6A6A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6278_50493"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.169556)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAppleDefault);
export default __webpack_public_path__ + "static/media/icon-apple-default.317d599087af62ae0903e618caf93c50.svg";
export { ForwardRef as ReactComponent };